export default __webpack_public_path__ + "static/media/Parrilla.6473ee18.svg";